import { readOnly } from './restutil';

export class UserManualDto {
  public static ApiUrl = 'api/user-manual';

  Id: number;
  Name: string;
  NameEn: string;
  NameEs: string;
  Created?: Date;
  Updated?: Date;
  @readOnly()
  IsDeleted: boolean;
  Type: UserManualType;
  Revision: number;
  Date: Date;
}

export class UserManualType {
  Pen: 0;
  Net: 1;
  Mooring: 2;
}
